import React, { useState } from 'react';
import classNames from 'classnames';

import css from './TextContent.module.scss';
import Paragraph from './Paragraphs/Paragraph';

const TextContent = ({
	heading,
	expand,
	data,
	customClass,
	linkType,
	linkUrl,
	linkText,
	textBelowCta,
}) => {
	const [shouldExpand, setShouldExpand] = useState(true);
	return (
		<section
			className={classNames(
				css.textContent,
				css[customClass],
				css[expand],
				expand && shouldExpand && css.hide
			)}
		>
			{heading && <h3>{heading}</h3>}
			{data && (
				<div className={css.para}>
					{data.map((props, index) => (
						<Paragraph
							id={props.id}
							isFirst={index === 0 ? true : false}
							expand={expand}
							shouldExpand={shouldExpand}
							{...props}
						/>
					))}
				</div>
			)}
			{expand && (
				<div className={classNames(css.expandLink, css[expand])}>
					<span
						className="linkUnderline"
						onClick={() => setShouldExpand(!shouldExpand)}
					>
						{shouldExpand ? 'Read more' : 'Read less'}
					</span>
				</div>
			)}
			{linkType && (
				<div className={css.cta}>
					{linkType === 'anchor' && (
						<a
							href={linkUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="linkUnderline"
						>
							{linkText}
						</a>
					)}
					{linkType === 'button' && (
						<a href={linkUrl} target="_blank" rel="noopener noreferrer">
							<button className="btn btnGreen">{linkText}</button>
						</a>
					)}
					{textBelowCta && <p className={css.textBelowCta}>{textBelowCta}</p>}
				</div>
			)}
		</section>
	);
};

export default TextContent;
